
import ActionCable from 'actioncable';
import config from './config';


const CableApp = {}
CableApp.cable = ActionCable.createConsumer(config.actionCableEndpoint)


window.CableApp = CableApp;
export default CableApp;


// WEBPACK FOOTER //
// ./src/cable.js